interface Config {
  API_URL: string;
}

// Set REACT_APP_API_URL to point at another API. The AWS deploy bakes
// REACT_APP_API_URL=/api so all calls hit the app's own origin, which CloudFront
// proxies to the tenant API (stat.membership-api.wobreeze.com) — no CORS.
// Falls back to the old prod host for legacy/local builds.
const config: Config = {
  API_URL:
    process.env.REACT_APP_API_URL ||
    'https://stat.membershipapi-prod.bitnata.com/api'
};

export default config;
